import { PageRequest } from '@models/models';

export class PaginationService {
	getResultsPage(
		currentPageRequest: PageRequest,
		totalItems: number,
		pageNumber: number = null,
		perPage: number = null,
		predicate: string = null,
		reverse = null
	): PageRequest {
		let changed = false;
		const pageRequest = JSON.parse(JSON.stringify(currentPageRequest));

		if (predicate) {
			pageRequest.sortCriteria.fieldName = predicate;
			pageRequest.sortCriteria.sortAscending = reverse;
			pageRequest.paging.pageNumber = 0;
			changed = true;
		}

		if (perPage) {
			pageRequest.paging.pageSize = perPage;
			pageRequest.paging.searchToken = null;
			pageRequest.paging.pageNumber = 0;
			changed = true;
		}
		if (pageNumber || pageNumber === 0) {
			pageRequest.paging.pageNumber = pageNumber;
			changed = true;
		}
		if (
			pageRequest &&
			totalItems !== 0 &&
			totalItems <
				(pageRequest.paging.pageNumber - 1) * pageRequest.paging.pageSize + 1
		) {
			console.log('out of page');
			pageRequest.paging.pageNumber = 1;
			changed = true;
		}

		if (changed) {
			return pageRequest;
		}
		return null;
	}

	changePage(
		currentPageRequest: PageRequest,
		totalItems: number,
		pageNumber: number = null
	): PageRequest {
		const pageRequest: PageRequest = JSON.parse(
			JSON.stringify(currentPageRequest)
		);
		let changed = false;

		if (pageNumber || pageNumber === 0) {
			pageRequest.paging.pageNumber = pageNumber;
			changed = true;
		}

		if (!changed) {
			return null;
		}

		return pageRequest;
	}

	calculatePageNumbers(totalItems: number, pageSize: number): Array<number> {
		let pagesCount;
		const pageNumbers = [];

		pagesCount = totalItems / pageSize;
		pagesCount = Math.ceil(pagesCount);

		for (let i = 0; i < pagesCount; i++) {
			pageNumbers[i] = i;
		}

		return pageNumbers;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/services/pagination/pagination.service.ts